import { declareString } from "@1js/localization";

export const NoWorkplaceResultHeading = declareString(
  "promptLibrary.noWorkplaceResultHeading",
  {
    text: "Your organization hasn't added prompts to their library yet",
    comment:
      "Heading displayed on the screen when the request to fetch Workplace prompts from the server-side retruns zero results.",
  }
);

export const NoWorkplaceResultSubHeading = declareString(
  "promptLibrary.noWorkplaceResultSubHeading",
  {
    text: "Once prompts have been added, you'll be able to access prompts created and published by your organization here. In the meantime, get started with prompts provided by Microsoft.",
    comment:
      "Subheading displayed on the screen when the request to fetch Workplace prompts from the server-side retruns zero results.",
  }
);

export const BrowseMicrosoftPrompts = declareString(
  "promptLibrary.browseMicrosoftPrompts",
  {
    text: "Browse Microsoft prompts",
    comment:
      "Button title displayed on the screen when the request to fetch Workplace prompts from the server-side retruns zero results.",
  }
);

export const NoWorkplaceResultHeadingParagraph = declareString(
  "promptLibrary.noWorkplaceResultHeadingParagraph",
  {
    text: "Find the best prompts for using Copilot effectively in your role. Our catalog is organized by department and role, making it easy to discover prompts tailored to your needs. Choose your department and role from the dropdown menu to filter prompts. We'll save your choices for your next visit.",
    comment:
      "Paragraph displayed on the screen when the request to fetch Workplace prompts from the server-side retruns zero results.",
  }
);
